module.exports = __webpack_public_path__ + "img/17_65.76537b6d.png";